// Section for import npm components -----------------------------------------------------------------------------------
import React, { useContext } from 'react';
import './bootstrap';

// Material UI ( mui )  components
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssVarsProvider } from '@mui/joy/styles';
import CssBaseline from '@mui/joy/CssBaseline';

// Section for import custom components --------------------------------------------------------------------------------
import CommonUtility from '@utils/Common';
import AppConfigProvider, { AppConfigContext } from '@providers/AppConfigProvider';

// @ts-ignore
import tailwindConfig from '../../../tailwind.config.js';

// Section for type definition -----------------------------------------------------------------------------------------
type ScreenSizes = {
  xs: number;
  sm: number;
  md: number;
  lg: number;
  xl: number;
  '2xl': number;
};

// Material UIのデフォルトfontFamilyにtailwindconfig.jsのfontFamilyを設定
const fontFamily = tailwindConfig.theme.extend.fontFamily.body.join(',');

const commonUtil = CommonUtility;
const screenSizes: ScreenSizes = {
  xs: commonUtil.convertStringToNumber(tailwindConfig.theme.extend.screens.xs),
  sm: commonUtil.convertStringToNumber(tailwindConfig.theme.extend.screens.sm),
  md: commonUtil.convertStringToNumber(tailwindConfig.theme.extend.screens.md),
  lg: commonUtil.convertStringToNumber(tailwindConfig.theme.extend.screens.lg),
  xl: commonUtil.convertStringToNumber(tailwindConfig.theme.extend.screens.xl),
  '2xl': commonUtil.convertStringToNumber(tailwindConfig.theme.extend.screens['2xl']),
};
// Section for Material UI theme setting -------------------------------------------------------------------------------
const theme = createTheme({
  typography: {
    fontFamily,
  },
  breakpoints: {
    values: {
      xs: screenSizes.xs,
      sm: screenSizes.sm,
      md: screenSizes.md,
      lg: screenSizes.lg,
      xl: screenSizes.xl,
    },
  },
});

// Section for render component ----------------------------------------------------------------------------------------

export default function App(props: any) {
  const { children } = props;

  // const isDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  const { appName } = useContext(AppConfigContext);
  const { pathRoot } = useContext(AppConfigContext);
  const { windowSize } = useContext(AppConfigContext);
  const { isMobile } = useContext(AppConfigContext);

  return (
    <React.StrictMode>
      <AppConfigProvider
        value={{
          appName,
          pathRoot,
          windowSize,
        }}
      >
        <ThemeProvider theme={theme}>
          <CssVarsProvider>
            <CssBaseline />
          </CssVarsProvider>
          {children}
        </ThemeProvider>
      </AppConfigProvider>
    </React.StrictMode>
  );
}
